import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalender5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconCalender5"><Path d="M15.5 3H8.5V4.25C8.5 4.66421 8.16421 5 7.75 5C7.33579 5 7 4.66421 7 4.25V3H4.75C3.7835 3 3 3.7835 3 4.75V7.5H21V4.75C21 3.7835 20.2165 3 19.25 3H17V4.25C17 4.66421 16.6642 5 16.25 5C15.8358 5 15.5 4.66421 15.5 4.25V3Z" fill="currentColor"/><Path d="M21 9H3V19.25C3 20.2165 3.7835 21 4.75 21H19.25C20.2165 21 21 20.2165 21 19.25V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalender5;
